<template>
  <div class="agent-top-bg">
    <div class="agent-desc uni-max-sm">
      <div id="agent-desc-text"></div>
      <div id='target' style="display:none;"><slot></slot></div>
      <button v-if="expanded && show" id="agent-desc-read-more" @click="readLess">Read Less</button>
      <button v-else-if="!expanded && show" id="agent-desc-read-more" @click="readMore">Read More</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "agent-show",
  props:['desc'],
  data() {
    return {
      expanded: false,
      show: true,
    }
  },
  methods: { 
    decodeHtml: function(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    },
    readMore: function() {
      document.getElementById("agent-desc-text").style.maxHeight = '1000vh';
      this.expanded = true;
    },
    readLess: function() {
      document.getElementById("agent-desc-text").style.maxHeight = '40px';
      this.expanded = false;
    }
  },
  mounted() {
    document.getElementById('agent-desc-text').innerHTML = this.decodeHtml(document.getElementById('target').innerHTML)
    const minH = document.getElementById("agent-desc-text").clientHeight;

    if (minH < 40) { this.show = false }
  }
};
</script>